const getIconColorSVGFill = (color) => {
    switch (color) {
        case 'primary':
            return `var(--iconLabelPrimaryInitial)`;
        case 'secondary':
            return `var(--textNeutralMedium)`;
        case 'tertiary':
            return `var(--textNeutralSoft)`;
        case 'positive':
            return `var(--textPositiveInitial)`;
        case 'negative':
            return `var(--textNegativeInitial)`;
        case 'iconPrimaryInitial':
            return `var(--iconPrimaryInitial)`;
        case 'warning':
            return `var(--iconWarningInitial)`;
        case 'surfaceCanvasPrimaryInitial':
            return `var(--surfaceCanvasPrimaryInitial)`;
        case 'labelNavigationTitle':
            return `var(--textNeutralSoft)`;
        case 'iconNeutralStrong':
            return `var(--iconNeutralStrong)`;
        case 'iconNeutralMedium':
            return `var(--iconNeutralMedium)`;
        case 'iconNeutralSoft':
            return `var(--iconNeutralSoft)`;
        case 'iconNeutralStrongInverted':
            return `var(--iconNeutralStrongInverted)`;
        case 'actionPrimaryInitial':
            return `var(--actionPrimaryInitial)`;
        case 'transparent':
            return ``;
        default:
            return `currentColor`;
    }
};

export { getIconColorSVGFill };
//# sourceMappingURL=colors.js.map
